import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Route, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { AuthService } from '../services/auth.service';

export function authGroupGuard(requiredGroups: string | string[]): CanActivateFn & CanMatchFn {
  return async (route: ActivatedRouteSnapshot | Route, state: RouterStateSnapshot | UrlSegment[]) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const messageService = inject(MessageService);

    const isAuth = await authService.isAuthenticated();
    const hasAccess = authService.isInGroup(requiredGroups);

    if (!isAuth || !hasAccess) {
      messageService.add({
        severity: 'warn',
        summary: 'You are not authorized to access this route.',
        life: 3000
      });
      router.navigate(['/']);
      return false;
    }

    return true;
  };
}
import { CanActivateChildFn } from '@angular/router';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';

export function authGroupGuardChild(requiredGroups: string | string[]): CanActivateChildFn {
  return async (route, state) => {
    const result = await authGroupGuard(requiredGroups)(route, state);

    if (result instanceof Promise) {
      return await result;
    }

    if (typeof (result as any)?.subscribe === 'function') {
      return await (result as Observable<boolean>).toPromise();
    }

    return result;
  };
}

